module.exports = __webpack_public_path__ + "static/media/screen1.d755224c.png";